import AxiosHttp from "./AxiosHttp";
import BaseEntity from "./BaseEntity";

export default abstract class BaseCrudService<T extends BaseEntity> extends AxiosHttp {
    /**
     * PAra ser implementado retornanao o caminho base dessa entidade.
     */
    abstract getBasePath(): string;

    /**
     * De preferência, salvar em Routes.ts uma rota e usar.
     */
    abstract getSearchRoute(): string;

    abstract getEditRoute(): string;

    async findById(id: number): Promise<T> {
        const res = await this.http.get(`${this.getBasePath()}/${id}`);
        return this.handleRespose(res);
    }

    /**
     *
     * @param searchTerm Texto a ser pesquisado na entidade.
     * @returns
     */
    async findByText(searchTerm: string, hasPreview?: boolean): Promise<T[]> {
        const res = await this.http.get(this.getBasePath(), { params: { searchTerm: searchTerm, hasPreview } });
        return this.handleRespose(res);
    }

    async insert(entity: T): Promise<T> {
        const res = await this.http.post(this.getBasePath(), entity);
        return this.handleRespose(res);
    }

    async update(entity: T) {
        const res = await this.http.put(`${this.getBasePath()}/${entity.id}`, entity);
        return this.handleRespose(res);
    }
}
